import * as LABELS_ACTION_TYPE from './labelConstants';
import { Label, LabelUpdateChanges } from './labelTypes';
import { getNewTransactionId } from '../../client/utils/undoRedo/undoRedoTransactionManager';
import { getGlobalClientId } from '../uid/ClientIdInstance';

/**
 * Creates a label-specific id from a generated element id.
 */
export const getNewLabelId = (id: string = getGlobalClientId().getElementId()) =>
    `${LABELS_ACTION_TYPE.LABEL_ID_PREFIX}${id}`;

export const loadLabels = (labels: Label[] = []) => ({
    type: LABELS_ACTION_TYPE.LABELS_LOAD,
    labels,
});

export const reloadLabels = (labels: Label[] = []) => ({
    type: LABELS_ACTION_TYPE.LABELS_RELOAD,
    labels,
});

export const createLabel = (label: Label, transactionId: number = getNewTransactionId()) => ({
    type: LABELS_ACTION_TYPE.LABEL_CREATE,
    label,
    transactionId,
    sync: true,
});

export const recreateLabel = (label: Label, transactionId: number = getNewTransactionId()) => ({
    type: LABELS_ACTION_TYPE.LABEL_RECREATE,
    label,
    transactionId,
    sync: true,
});

export const updateLabel = (labelId: string, changes: LabelUpdateChanges) => ({
    type: LABELS_ACTION_TYPE.LABEL_UPDATE,
    labelId,
    changes,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const deleteLabel = (labelId: string, elementIds: string[] = []) => ({
    type: LABELS_ACTION_TYPE.LABEL_DELETE,
    labelId,
    elementIds,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const selectLabels = (labelId: string, elementId: string, selectedElementId: string = elementId) => ({
    type: LABELS_ACTION_TYPE.LABEL_SELECT,
    selectedLabel: { _id: labelId, elementId, selectedElementId },
});

export const deselectLabels = () => ({
    type: LABELS_ACTION_TYPE.LABEL_SELECT,
    selectedLabel: null,
});

export const markLabelsAsStale = () => ({
    type: LABELS_ACTION_TYPE.LABELS_MARK_STALE,
});
